export const numberWithCommas = (value: string): string => {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}
// function to replace long string with ... based on string length value
export const displayEllipticalString = (string: string, stringLength: number) => {
  return string.slice(0, stringLength).concat('...')
}